import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Section' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        flex: '1 0 0'
    },
    title: {
        display: 'flex',
        padding: '12px 16px',
        alignItems: 'flex-start',
        gap: 10,
        color: '#8E8E8E',
        fontSize: 12,
        fontWeight: 600,
        lineHeight: '16px',
        letterSpacing: '1.2px',
        textTransform: 'uppercase'
    }
});
